<template>
  <div class="page repayment">
    <navigation
      :theme="{ background: '#43476B', color: '#fff' }"
      arrTheme="w"
    >{{
      platform === 'TMD' ? '我的借款' : '我要还款'
    }}</navigation>
    <div class="container">
      <div 
        class="tips" 
        @click="goWithdraw"
        data-sensors-exposure-property-element_positon="banner"
        data-sensors-exposure-event-name="Element_Exposure"
        :data-sensors-exposure-property-element_type="tips.banner.textKey"
        v-if="tips && tips.banner && tips.banner.text"
      >
        <img src="./images/img_shou@2x.png">
        {{ tips.banner.text }} 
      </div>
      <!-- 还款展示 -->
      <div class="repayment-panel">
        <div class="panel-header">
          <template v-if="orderList.length">
            <div
              class="platform"
              v-if="platform !== 'TMD'"
            >
              <img
                class="icon"
                :src="platformShow.icon"
                alt=""
              />
              <span class="name">{{ platformShow.name }}</span>
            </div>

            <div
              class="card-info"
              :class="{tmd: platform === 'TMD'}"
            >
              <div class="card-description">
                <span>应还总额<em>(元)</em></span>
              </div>

              <div class="card-amount">
                {{ totalAmount | currency }}
              </div>
            </div>
          </template>
          <p v-else>当前无进行中借款</p>
        </div>

        <div class="panel-gutter"></div>

        <div class="panel-content">
          <template v-if="orderList.length ">
            <div
              class="cell-title"
              v-if="platform !== 'TMD'"
            >
              待还款订单
            </div>
            <div
              class="cell-title"
              v-else
            >
              进行中 ({{ orderList.length }}) 笔
            </div>

            <!-- 分期账单 -->
            <div class="installment">
              <nd-cell
                @click="goRepaymentDetail(item)"
                v-for="(item, index) in orderList"
                :key="index"
                class="installment-item"
                :content="true"
              >
                <span slot="title">借款：{{ item.applyAmount | currency }}</span>

                <span
                  slot="text"
                  v-if="item.billStatus === 'OVERDUE'"
                ><span class="overdue">逾期应还(元)</span></span>
                <span
                  slot="text"
                  v-else-if="item.billStatus === 'PRE_PAY'"
                >当前可还(元)</span>
                <span
                  slot="text"
                  v-else-if="item.billStatus === 'BILL_DUE'"
                >到期应还(元)</span>
                <span
                  slot="text"
                  class="disabled"
                  v-else
                ><span class="disabled">查看详情</span></span>

                <div class="item-detail">
                  <span class="paydate">还款日：每月{{
                    item.dueDate | date('D')
                  }}日</span>
                  <span
                    class="currency"
                    v-if="['OVERDUE','PRE_PAY','BILL_DUE'].includes(item.billStatus) && item.schdAmt"
                    :class="{ overdue: item.hasOverdue }"
                  >{{ item.schdAmt | currency }}</span>
                </div>
              </nd-cell>
            </div>
          </template>
        </div>
      </div>

      <div
        class="custom-phone"
        v-if="platform === 'YZD'"
      >
        <p
          class="phone"
          @click="callPhone"
        >服务监督热线: {{ tel }}</p>
        <p class="time">请在工作日 09:00 - 18:00拨打</p>
      </div>
    </div>
    <dragCoupon :flow="tips.flow" v-if="tips && tips.flow" ftype=MY_LOAN_LIST></dragCoupon>
    <nd-dialog
      class="ios-protocol"
      v-model="iosProtocolVisible"
      @close="disagreeProtocol"
      title="个人信息使用授权书"
      closeBtn
    >
      <div
        slot="footer"
        class="ios-protocol-footer"
      >
        <nd-button
          class="small btn"
          @click="agreeProtocol"
        >我已阅读并同意</nd-button>
      </div>
      <div class="protocol-content protocol">
        <section class="content">
          <p class="text tab-0 bolder">
            重要提示：
          </p>
          <p class="text bolder">
            为了保障您的合法权益，您应当阅读并遵守《个人信息使用授权书》（以下简称“本授权书”），请您务必审慎阅读、充分理解本授权书全部条款内容，特别是免除或者减轻重庆市崇天小额贷款有限公司（以下简称“崇天小贷”）及崇天小贷合作方（以下合称“被授权人”）责任，或限制您权利的条款，其中免除或者减轻责任条款将以加粗形式提示您注意。
          </p>
          <p class="text">
            <span class="bolder">您知晓并确认您在使用崇天小贷的贷后管理服务（以下简称“本服务”）时已阅读并接受本授权书所有条款，否则您应立即停止使用本服务。</span>您的点击确认行为即视为您已阅读并同意本授权书条款的约束。崇天小贷与合作方将按照本授权书的规定向您收集、使用、对外提供您的个人信息。
          </p>
          <p class="text bolder">
            您同意以数据电文形式订立本授权书，您通过网络页面点击确认或以其他方式选择接收并确认本授权，即表示您同意本授权书的全部内容并受本授权书约束。
          </p>
          <p class="text">
            您充分理解并同意，在<span class="bolder">您向崇天小贷申请小额贷款服务的过程中，为准确、客观、全面、及时地评估您本人的信用等级和授信额度，并为您提供适合且优质的服务，就崇天小贷收集及使用您本人的相关必要个人信息事项，您同意并授权如下：</span>
          </p>
          <p class="title">
            一、您同意并授权崇天小贷可以从合作方收集（且合作方可以向崇天小贷提供）您在使用合作方的相关服务时向其提供的您的下述个人信息：
          </p>
          <p class="text bolder">
            1.为实名制管理之目的
          </p>
          <p class="text">
            （1）<span class="bolder">相关身份信息</span>（包括姓名、身份证号、身份证有效期、身份证影像件等）；
          </p>
          <p class="text">
            （2）<span class="bolder">联系方式</span>（包括住址信息、手机号）；
          </p>
          <p class="text">
            （3）<span class="bolder">学历信息</span>（如需）；
          </p>
          <p class="text">
            （4）<span class="bolder">银行卡信息</span>（包括银行卡类型、卡号、有效期、开户行名称、银行卡预留手机号）；
          </p>
          <p class="text">
            （5）您使用崇天小贷的服务时系统可能通过Cookies或其他方式自动采集的
            <span class="bolder">技术或设备信息</span>（包括设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们的服务的其他程序所提供的配置信息、您的IP地址、移动设备所用的版本和设备识别码（仅用于账户安全），您曾使用的移动应用和其他软件的信息、以及您曾经使用该等移动应用和软件的信息）；
          </p>
          <p class="text">
            （6）<span class="bolder">位置信息</span>（指您开启设备定位功能并使用崇天小贷的服务时，收集的有关您位置的信息，包括通过GPS或WiFi等方式收集的您的地理位置实时信息、您提供的账户信息中包含的您的所在地区信息，您上传的照片中包含的地理标记信息，您可以通过关闭定位功能停止对您的地理位置信息的收集）；
          </p>
          <p class="text">
            （7）<span class="bolder">面部特征</span>（基于审核您身份或确认相应授权真实性时，通过人脸识别等技术采集的您的人脸头像图片）；
          </p>
          <p class="text">
            （8）其他为申请崇天小贷的消费信贷服务所必须提供的信息。
          </p>
          <p class="text bolder">
            2.为风险审核与信用评估之目的
          </p>
          <p class="text">
            为了准确评估您的信贷资格、信用及偿付能力，进行风控审核与评估，您同意我们收集您的性别、职业、学历、<span class="bolder">社保卡、公积金信息、纳税信息、收入状况、消费信息、信贷记录、不良信息及联系人信息。</span>
          </p>
          <p class="text margin-top-40 bolder">
            二、您理解并授权，崇天小贷崇天小贷有权为本授权书第三条载明的用途获取、存储、使用、加工分析前述合作方通过加密方式传递的个人信息。如崇天小贷通过技术手段对您的个人信息进行不可识别到个人的脱敏处理，您理解并同意崇天小贷对此类数据的保存及处理无需另行通知并征得您的同意。
          </p>
          <p class="text margin-top-40 bolder">
            三、您理解并同意，崇天小贷可能将您提供或在向您提供服务过程中收集的信息作下列用途：
          </p>
          <p class="text">
            （1）用于信用评估、风险控制及向您提供小额贷款服务；
          </p>
          <p class="text">
            （2）用于注册登录、身份验证、额度申请、贷款申请、征信查询、贷后管理；
          </p>
          <p class="text">
            （3）用于安全防范、反欺诈、存档和备份；
          </p>
          <p class="text">
            （4）用于检测、评估、提高和改善崇天小贷现有产品或服务效果；
          </p>
          <p class="text">
            （5）帮助崇天小贷了解和分析用户需求，设计新产品和运作模式；
          </p>
          <p class="text">
            （6）用于向您收取应支付的各类费用（如有）；
          </p>
          <p class="text">
            （7）用于经您授权的其他目的。
          </p>

          <p class="text margin-top-40 bolder">
            四、崇天小贷将会在下列任一情形发生时将您的信息与第三方进行共享：
          </p>
          <p class="text">
            （1）某些产品或服务由崇天小贷关联方提供或由关联方与崇天小贷共同提供，向关联方共享；
          </p>
          <p class="text">
            （2）某些产品或服务由合作方（包括但不限于合作金融机构、身份验证服务商、风控服务方、支付服务方等）提供或由崇天小贷与合作方共同提供，向合作方共享；
          </p>
          <p class="text">
            （3）根据适用的法律法规、法律程序、诉讼目的向行政机关、司法机构等法定机关共享；
          </p>
          <p class="text">
            （4）向依法设立的征信机构、行业协会、第三方数据服务机构或有关法律、监管机构许可的类似机构共享；
          </p>
          <p class="text">
            （5）在您发生逾期违约时向您的交易对手、担保机构、债权转让项下的受让人共享；
          </p>
          <p class="text">
            （6）崇天小贷发生收并购或其他资本市场活动时向外部专业中介机构共享；
          </p>
          <p class="text">
            （7）获得您的同意或授权的其他情形。
          </p>

          <p class="text margin-top-40">
            五、崇天小贷将会采取各种制度、安全技术、程序等严格保护您的个人信息安全，防止未经授权的访问、篡改、使用、泄露和破坏。<span class="bolder">除以下任一情形之外，崇天小贷不会将您的个人信息对外公开或向第三方披露：</span>
          </p>
          <p class="text">
            （1）根据法律、法规的规定或监管等政府主管部门的强制性要求；
          </p>
          <p class="text">
            （2）为保护崇天小贷或您的合法权益；
          </p>
          <p class="text">
            （3）在紧急情况下，为保护其他用户或者第三方人身安全；
          </p>
          <p class="text">
            （4）您本人或其监护人授权；
          </p>
          <p class="text">
            （5）业务转让要求，崇天小贷有权转让贷款项下债权，您同意在这些交易中，客户信息是所转让业务资产中的一部分，与该等业务一并提供给受让方，但这些信息仍然受制于转让前已有的个人信息授权所作出承诺，您做出其他授权的除外。
          </p>
          <p class="text margin-top-40 bolder">
            授权人声明：
          </p>
          <p class="text bolder">
            本授权书是本人向合作方、崇天小贷做出的单方承诺，效力具有独立性，不因本人与合作方及崇天小贷签署的任何条款的无效而无效。
          </p>
          <p class="text bolder">
            以上授权期限为本人做出授权承诺之日起至本人与崇天小贷及合作方的所有业务终结之日止(处理本人征信异议除外)。
          </p>
          <p class="text">
            如本人与以上被授权人发生任何争议或纠纷，首先应友好协商解决；<span class="bolder">协商不成的，本人同意将纠纷或争议提交重庆市南岸区人民法院诉讼解决。</span>本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律（仅为本协议之目的，不包括香港、澳门、台湾地区法律）。
          </p>
          <p class="text bolder">
            本人已知悉本授权书所有内容（特别是加粗字体内容）的意义及因此产生的法律效力，自愿做出上述授权。本授权书是本人真实的意思表示，一经签署即视为同意本授权书全部内容，并同意承担由此带来的一切法律后果。
          </p>
          <p class="text margin-top-40">
            特此授权！
          </p>
          <p class="text margin-top-40">
            授权人：
          </p>
          <p class="text margin-top-40">
            授权日期：
          </p>
        </section>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { mockHrefJump, setKey, getKey, isTMDMiniprogram } from '../../assets/utils'
import wx from 'weixin-webview-jssdk'
export default {
  name: 'repayment',

  customReadyNotify: true,
  components: {
    dragCoupon: () => import('./components/drag-coupon')
  },
  data () {
    return {
      platform: this.$route.query.type,
      orderList: [],
      iosProtocolVisible: false,
      tel: '023-67561036',
      tips: {},
      isQueryChannel: this.$route.query.isQueryChannel === 'T' // 是否部分查询
    }
  },
 
  beforeDestroy () {
    this.showList = false
  },
  computed: {
    platformShow () {
      const platform = getKey('platform')
      const result = platform.find(
        (item) => item.loanPlatform === this.platform
      )
      if (result) {
        return {
          name: result.loanPlatformName,
          icon: result.iconUrl
        }
      }
      return {
        name: platform['TMD'] && platform['TMD'].loanPlatformName,
        icon: platform['TMD'] && platform['TMD'].iconUrl
      }
    },

    ...mapState('order', {
      totalAmount: (state) => state.platOrder.totalAmount
    }),

    ...mapState('user', {
      userInfo: (state) => state.userInfo,
      creditStatus: (state) => state.quotaInfo.creditStatus,
      loanList: (state) => state.quotaInfo.loanList,
      lockingDay: (state) => state.quotaInfo.lockingDay
    })
  },

  async created () {
    setKey('repayEntry', '/repayment')
    this.$bus.$emit('ready')
    this.getLoanBilltip()
    await this.getUserInfoX()
    await this.getPlatform()
    this.platform = this.$route.query.type || 'TMD'
    await this.getOrderList()
    if (!this.orderList || !this.orderList.length) {
      await this.getLimit()
    }

    const terminal = this.$storage.get('terminal') || ''
    if (terminal === 'IOS') {
      if (this.$storage.get('iosProtosolAgree') !== 'T') {
        this.iosProtocolVisible = true
      }
    }
  },

  methods: {
    ...mapActions('order', ['getOrderListX', 'getPlatformX', 'loanBillTipX']),
    ...mapActions('user', ['getLimitX', 'getUserInfoX']),
    goWithdraw () {
      this.$sensors.track('$WebClick', { element_type: this.tips.banner.textKey })
      this.$router.push('/middle/limit')
    },
    async getLoanBilltip () {
      const { success, data } = await this.loanBillTipX({
        popType: 'MY_LOAN_LIST'
      })
      if (success) {
        this.tips = data
      }
    },
    // 获取额度
    getLimit () {
      return this.getLimitX({ loanPlatform: this.platform })
    },
    goRepaymentDetail (item) {
      let status = 0
      if (item.hasOverdue) {
        status = 0
      } else if (item.canRepay) {
        status = 1
      } else {
        status = 2
      }
      this.$report({
        id: 10027,
        args: {
          status: status,
          position: this.platform,
          target: item.orderId
        }
      })
      let params = {
        orderId: item.orderId, // 订单号（颜值贷）
        loanPlatform: this.platform,
        productCd: item.productCd
      }
      params.orderId = item.orderId
      this.$router.push({ path: '/repayment/detail', query: params })
    },

    async getOrderList () {
      // isQueryChannel: this.isQueryChannel
      const res = await this.getOrderListX({ loanPlatform: this.platform })
      if (
        res.code === '000000' &&
        res.data &&
        res.data.sysOrderLine &&
        res.data.sysOrderLine[0]
      ) {
        this.orderList = res.data.sysOrderLine[0].orderOutLineInfo || []
      }
    },

    // IOS跳转用户不同意协议
    disagreeProtocol () {
      this.$bus.$emit('nativeBack')
    },

    // IOS跳转用户同意协议
    agreeProtocol () {
      this.iosProtocolVisible = false
      this.$storage.set('iosProtosolAgree', 'T')
    },

    callPhone () {
      console.log('tel')
      mockHrefJump(`tel:${this.tel}`)
    },
    clickWithdrawButtonHandler () {
      if (isTMDMiniprogram()) {
        wx.miniProgram.postMessage({
          data: { 
            eventType: 'PROCESS'
          }
        })
        wx.miniProgram.navigateBack()
        return
      }
      this.$router.push('/middle/limit')
      // if (this.loanList && this.loanList.length > 0 && (this.loanList[0].loanStatus === 'LOANING' || this.loanList[0].loanStatus === 'LOAN_WAIT_VIP')) {
      //   this.$router.push(
      //     `/withdraw/result?loanApplyNo=${this.loanList[0].serialNo}`
      //   )
      // } else {
      //   this.$router.push('/withdraw/index')
      // }
    },
    // 获取平台枚举
    async getPlatform () {
      const res = await this.getPlatformX()
      if (res.code === '000000') {
        setKey('platform', res.data)
      }
    }
  }
}
</script>
<style lang="less" >
@import "../../assets/less/mixin.less";

.page.repayment {
  display: flex;
  flex-direction: column;
  background-color: #43476b;
  overflow: hidden;
  height: 100%;
  
  .container {
    position: relative;
    .tips {
      display: flex;
      height: 80px;
      background: #3a43d6;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
      align-items: center;
      position: absolute;
      width: 100%;
      img {
        width: 110px;
        margin-right: 10px;
      }
    }
  }
  .repayment-panel {
    flex: 1;
    margin: 100px 32px 96px;
    border-radius: 30px;
    background-color: #ffffff;
    overflow: hidden;

    .panel-header {
      position: relative;
      height: 286px;
      padding: 0 25px;
      box-sizing: border-box;
      overflow: hidden;
      > p {
        font-size: 36px;
        color: #333333;
        margin-top: 175px;
        text-align: center;
      }

      .platform {
        width: 100%;
        height: 48px;
        margin-top: 47px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon {
          width: 48px;
          height: 48px;
        }

        .name {
          font-size: 32px;
          padding-left: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }

      .card-info {
        position: absolute;
        top: 129px;
        left: 0;
        width: 100%;
        &.tmd {
          top: 99px;
        }
        .card-description {
          font-size: 26px;
          margin: 0 100px;
          height: 37px;
          line-height: 37px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @fc2;
          display: flex;
          flex-direction: row;
          justify-content: space-around;

          span {
            em {
              font-style: normal;
              padding-left: 8px;
              color: @fc4;
            }
          }
        }

        .card-amount {
          font-size: 66px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          text-align: center;
        }
      }
    }

    .panel-gutter {
      height: 28px;
      width: 100%;
      background-image: url(../repayment/images/line.png);
      background-size: cover;
    }

    .panel-content {
      padding: 0 29px 30px;
      height: calc(100% - 314px);
      overflow: auto;
      box-sizing: border-box;

      .cell-title {
        margin-top: 44px;
        margin-bottom: 60px;
        font-size: 32px;
        text-align: left;
        color: #666666;
      }

      .installment {
        .installment-item {
          .nd-cell-header {
            height: 42px;
            font-size: 30px;
            padding: 0;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;

            .title {
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
            }

            .text {
              .overdue {
                color: @fc-error;
              }

              .pending {
                color: #4b94f0;
              }

              .disabled {
                color: @fc4;
              }
            }
          }

          & + .installment-item {
            margin-top: 60px;
          }

          .item-detail {
            margin-left: 5px;
            margin-right: 20px;
            height: 37px;
            line-height: 37px;
            margin-top: 7px;
            font-size: 26px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @fc4;
            .currency {
              width: 170px;
              color: #333;
            }
            .overdue {
              color: @fc-error;
            }

            .pending {
              color: #4b94f0;
            }

            .disabled {
              color: @fc4;
            }
          }
        }
      }
      > img {
        display: block;
        width: 360px;
        height: 221px;
        margin: 114px auto 57px;
      }
      .btn {
        display: block;
        width: 320px;
        height: 80px;
        line-height: 80px;
        margin: auto;
      }
    }
  }

  .ios-protocol {
    .protocol-content {
      height: 600px;
      overflow: auto;
    }

    .dialog-footer {
      padding: 20px 50px 30px !important;

      .ios-protocol-footer {
        margin: 0 auto;
      }
    }
  }
  .custom-phone {
    text-align: center;
    padding: 0 75px 75px 75px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 33px;
  }
}
</style>
